import { RootState } from '../redux';

export const selectCategories = (state: RootState) => {
  return state.categories;
};
